import { render } from "./SharedApp.vue?vue&type=template&id=0c15c3be&scoped=true"
import script from "./SharedApp.vue?vue&type=script&lang=js"
export * from "./SharedApp.vue?vue&type=script&lang=js"

import "./SharedApp.vue?vue&type=style&index=0&id=0c15c3be&scoped=true&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c15c3be"]])

export default __exports__